export const STATUS_TICKETS: Record<string, string> = {
    created: 'created',
    received: 'received',
    in_progress: 'in_progress',
    assigned: 'assigned',
    complete: 'complete',
};
